import { render, staticRenderFns } from "./ForgotCredentials.vue?vue&type=template&id=2978b11e&scoped=true&"
import script from "./ForgotCredentials.js?vue&type=script&lang=js&"
export * from "./ForgotCredentials.js?vue&type=script&lang=js&"
import style0 from "./ForgotCredentials.scss?vue&type=style&index=0&id=2978b11e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2978b11e",
  null
  
)

export default component.exports